const apiUrl = 'https://price-system.com/api/' //线上
// const apiUrl = 'http://10.10.17.68:3000/'   /// 测试
export {
    apiUrl
}